<template>
  <div
    :class="{
      'bg-white': isLoadsDashboard,
      'bg-steel-100': !isLoadsDashboard,
    }"
  >
    <div
      class="bg-white py-4"
      :class="{
        'bg-white': isLoadsDashboard,
        'lg:bg-steel-100': !isLoadsDashboard,
      }"
    >
      <div class="table-max m-auto mt-4 px-6 md:pr-0">
        <div class="flex items-center justify-between pr-2">
          <div class="flex flex-col items-start">
            <h1 class="text-left text-3xl text-dark-blue">
              {{ title }}
            </h1>
          </div>

          <div
            v-if="isLoadsDashboard && isDesktop"
            class="flex items-center gap-2"
          >
            <LoadSortMenu :is-disabled="doesNotMeetRequirements"></LoadSortMenu>

            <ButtonComponent
              :disabled="doesNotMeetRequirements"
              @click="handleRefreshView"
            >
              <img
                src="@/assets/refresh-icon.svg"
                alt="fresh icon"
              />

              Refresh
            </ButtonComponent>

            <ButtonComponent
              :disabled="doesNotMeetRequirements"
              variant="primary"
              @click="openPostCapacityModal"
            >
              Post Capacity
            </ButtonComponent>
          </div>
        </div>

        <LoadsSearchAndFilter
          v-if="!isDesktop && isLoadsDashboard"
          placeholder="Search Loads"
          :is-loads-dashboard="isLoadsDashboard"
          :is-missing-origin-state="isMissingOriginState"
          @search-loads="searchLoadsInput"
        ></LoadsSearchAndFilter>

        <div
          v-if="tabs?.length"
          class="mt-2 flex w-full justify-between pt-4 lg:w-[300px] lg:px-0"
        >
          <span
            v-for="tab in tabs"
            :key="tab.title"
            class="mx-4 flex-1 cursor-pointer"
            :class="
              currentTab === tab.title
                ? 'border-b-2 border-neutral-subtle-yellow text-base font-semibold text-neutral-subtle-yellow'
                : 'text-gray text-base'
            "
            @click="handleTabSelection(tab.title)"
          >
            <p class="capitalize">
              {{ tab.title }}
            </p>
          </span>
        </div>
      </div>
    </div>

    <div class="table-max m-auto">
      <div
        v-if="isLoadsDashboard && !isDesktop"
        class="max-w-screen ml-6 mt-4 flex justify-between gap-3 overflow-scroll sm:mx-6"
      >
        <!-- <button-main
          variant="tertiary"
          class="flex !h-[48px] min-w-max max-w-[160px] items-center justify-center gap-2 border border-gray-200 !bg-white !p-3 text-1md !font-medium !text-neutral-subtle-bold"
          @click="handleLoadSort"
        >
          <img
            src="@/assets/arrows-up-and-down.svg"
            alt="arrows icon"
          />
          Sort: {{ postingSort === 'asc' ? 'Oldest' : 'Latest' }}
        </button-main> -->

        <!-- <LoadFilterButtons
          :white-bg="true"
          :is-scrollable="false"
        ></LoadFilterButtons> -->
      </div>

      <div
        v-if="!isDesktop"
        class="flex items-center justify-between px-6"
      >
        <div
          v-if="!doesNotMeetRequirements"
          class="w-full"
        >
          <p v-if="isLoading"></p>
          <p
            v-else-if="!isLoadsDashboard"
            class="w-max"
          >
            {{ numberOfLoads }}
          </p>
          <div
            v-else
            class="flex justify-between gap-3"
          >
            <p class="text-left">
              {{ numberOfLoadsOnLoadBoard }}
            </p>

            <div v-if="loads?.length > 0">
              <ButtonComponent
                variant="subtle"
                class="min-w-max"
                @click="openSortBottomSheet"
              >
                <img
                  src="@/assets/arrows-up-and-down.svg"
                  alt="arrows icon"
                />
                Sort: {{ postingSort }}
              </ButtonComponent>
            </div>
          </div>
        </div>

        <div
          v-if="!isLoadsDashboard"
          class="flex min-w-max cursor-pointer gap-1"
          @click="openSortBottomSheet"
        >
          <img
            src="@/assets/sort-arrows.svg"
            alt="sort icon"
          />
          Sort by
        </div>
      </div>

      <div v-if="isDesktop">
        <div class="flex flex-row pb-4 pr-2">
          <LoadFiltersDesktop
            :is-loads-dashboard="isLoadsDashboard"
            :is-resetting-search="isResettingSearch"
            :is-refresh-search="isRefreshSearch"
          ></LoadFiltersDesktop>

          <div
            v-if="isLoading"
            class="flex w-full items-center justify-center rounded-lg border-2 border-steel-300 bg-white"
            :class="{
              'h-[calc(100vh-166px)]': !bannerError,
              'h-[calc(100vh-194px)]': bannerError,
            }"
          >
            <div>
              <img
                class="loading m-auto h-12 w-12"
                src="@/assets/loading-v2-yellow.svg"
                alt="loading spinner"
              />
              <p class="mt-2 text-base">Loading</p>
            </div>
          </div>

          <div
            v-else-if="doesNotMeetRequirements"
            :class="{
              'm-auto': isMissingOriginState,
              'mx-auto': !isMissingOriginState,
            }"
          >
            <div
              v-if="isMissingOriginState"
              class="m-auto flex flex-col items-center gap-3"
            >
              <img
                src="@/assets/loads/semi-truck.svg"
                alt="semi truck"
              />

              <h3
                class="text-left text-xl font-semibold text-neutral-subtle-bold"
              >
                Let's get you on the road
              </h3>
              <p class="text-center font-normal text-neutral-subtle-bold">
                To get started, select an origin and/or a broker.
              </p>
            </div>
            <div
              v-else
              class="m-auto mt-16 flex h-min w-[500px] flex-col gap-3 rounded-lg border border-steel-300 bg-white p-4 shadow-md"
            >
              <h3
                class="text-left text-xl font-semibold text-neutral-subtle-bold"
              >
                {{ loadErrorTitleMessage }}
              </h3>
              <p
                v-if="unauthorizedTfxUser"
                class="text-left font-normal text-neutral-subtle-bold"
              >
                Not sure why? Learn more about potential reasons
                <a
                  href="https://help.highway.com/en/articles/12044805-why-can-t-i-see-loads"
                  target="_blank"
                  class="underline"
                  >here</a
                >
              </p>
              <p
                v-else
                class="text-left font-normal text-neutral-subtle-bold"
              >
                {{ loadErrorMessage }}
              </p>

              <!-- <div
                v-if="unauthorizedTfxUser"
                class="ml-auto mt-4 flex"
              >
                <ButtonComponent
                  class="flex-1 justify-center !py-3"
                  variant="primary"
                >
                  <router-link
                    :to="{
                      name: 'ELDConnections',
                    }"
                  >
                    My Equipment
                  </router-link>
                </ButtonComponent>
              </div> -->
            </div>
          </div>

          <div
            v-else-if="loads?.length === 0"
            class="flex h-[calc(100vh-194px)] w-full flex-col items-center justify-center gap-3 rounded-lg border-2 border-steel-300 bg-white"
          >
            <img
              class="h-20 w-20"
              src="@/assets/magnify.svg"
              alt="magnify icon"
            />

            <div class="mx-20 flex flex-col gap-3">
              <h3 class="text-center text-lg text-gray-400">
                No results found.
              </h3>
              <h3 class="text-center text-lg text-gray-400">
                We're just getting started and new loads are being posted every
                day as more brokers join the Trusted Freight Exchange. Try
                adjusting your search filters to see more options.
              </h3>
            </div>
          </div>

          <div
            v-else-if="isLoadsDashboard"
            class="h-min w-full rounded-md border border-steel-300 bg-steel-100 shadow-md"
          >
            <div
              class="grid grid-cols-21 rounded-t-md border-transparent bg-steel-100 px-2 py-3 text-left font-semibold"
            >
              <p class="col-span-3 text-xs">Broker</p>
              <p class="col-span-3 text-xs">Origin</p>
              <p class="col-span-3 text-xs">Destination</p>
              <p class="col-span-2 text-xs">Trip</p>
              <p class="col-span-2 text-xs">Equipment</p>
              <p class="col-span-2 text-xs">Weight</p>
              <p class="col-span-2 text-xs">Type</p>
              <p class="col-span-4 pl-4 text-center text-xs">Rate</p>
            </div>

            <div
              class="overflow-scroll"
              :class="{
                'max-h-[calc(100vh-270px)]': !bannerError,
                'max-h-[calc(100vh-300px)]': bannerError,
              }"
            >
              <router-link
                v-for="load in loads"
                :key="load.id"
                :to="{
                  name: routerLinkName,
                  params: { id: load.id },
                }"
                class="grid grid-cols-21 border-t-2 border-steel-300 bg-white pl-2 pr-5 font-normal text-neutral-subtle hover:bg-gray-50"
                @mouseenter="handleMouseOver(load)"
                @click="handleSelectLoad(load)"
              >
                <div
                  class="col-span-3 flex flex-col items-start justify-center gap-1 py-3"
                >
                  <BrokerImage
                    :image-src="load?.broker_logo?.url"
                    :broker-name="load?.broker_name"
                  >
                  </BrokerImage>

                  <p
                    v-if="load.last_posted_at"
                    class="text-left text-1xs text-neutral-subtle"
                  >
                    Posted {{ fromNowFirstUnit(load.last_posted_at) }} ago
                  </p>
                </div>

                <div
                  class="col-span-3 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadOrigin(load) }}
                  </p>

                  <p class="text-xs font-normal text-neutral-subtlest">
                    {{
                      formatStopDate(
                        load?.pickup_time,
                        load?.pickup_time_timezone,
                        load?.pickup_has_time
                      )
                    }}
                  </p>
                </div>

                <div
                  class="col-span-3 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadDestination(load) }}
                  </p>

                  <p class="text-xs text-neutral-subtlest">
                    {{
                      formatStopDate(
                        load?.dropoff_time,
                        load?.dropoff_time_timezone,
                        load?.dropoff_has_time
                      )
                    }}
                  </p>
                </div>

                <div class="col-span-2 flex items-center justify-start py-3">
                  <p
                    v-if="load.posted_miles"
                    class="text-xs"
                  >
                    {{
                      (Math.round(load.posted_miles * 10) / 10).toLocaleString()
                    }}
                    mi
                  </p>
                  <p
                    v-else
                    class="text-xs"
                  >
                    -
                  </p>
                </div>

                <div class="col-span-2 flex items-center justify-start py-3">
                  <p class="text-left text-xs">
                    {{
                      load.posted_equipment_types?.length > 0
                        ? formatEquipmentType(load.posted_equipment_types)
                        : '-'
                    }}
                  </p>
                </div>

                <div class="col-span-2 flex items-center justify-start py-3">
                  <p class="text-xs">
                    {{ loadWeight(load.weight, load.weight_unit) }}
                  </p>
                </div>

                <div class="col-span-2 flex items-center justify-start py-3">
                  <p
                    v-if="load?.is_hazmat_required"
                    class="rounded-md bg-steel-100 px-2 py-[2px] text-left text-xs"
                  >
                    Hazmat
                  </p>
                  <p
                    v-if="load?.is_teams_required"
                    class="rounded-md bg-steel-100 px-2 py-[2px] text-left text-xs"
                  >
                    Teams
                  </p>
                  <p
                    v-if="load?.is_power_only_required"
                    class="rounded-md bg-steel-100 px-2 py-[2px] text-left text-xs"
                  >
                    Power Only
                  </p>
                </div>

                <div class="col-span-4 flex items-center py-3">
                  <div
                    class="flex w-full items-end gap-2"
                    :class="
                      loadRateText(
                        load?.lane_prediction?.posted_rate_assessment
                      )
                        ? 'justify-between'
                        : 'justify-end'
                    "
                  >
                    <span
                      v-if="
                        loadRateText(
                          load?.lane_prediction?.posted_rate_assessment
                        )
                      "
                      class="ml-auto min-w-max rounded px-[6px] py-[2px] text-xs"
                      :class="
                        loadRateClass(
                          load?.lane_prediction?.posted_rate_assessment
                        )
                      "
                      >{{
                        loadRateText(
                          load?.lane_prediction?.posted_rate_assessment
                        )
                      }}</span
                    >
                    <div class="flex min-w-[64px] flex-col items-end">
                      <p class="text-xl font-semibold">
                        {{ formatPrice(load.price, 0) }}
                      </p>
                      <p
                        v-if="load?.price && loadRate(load?.rate_per_mile)"
                        class="text-xs"
                      >
                        {{ loadRate(load?.rate_per_mile) }}/mi
                      </p>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>

            <section
              v-if="!isLoading"
              class="relative flex min-h-[61px] items-center justify-center rounded-b-md border-t border-steel-300 bg-white py-2"
            >
              <p class="absolute left-3 top-6 text-xs text-steel-700">
                Showing {{ loads?.length }} load{{
                  loads?.length > 1 ? 's' : ''
                }}
                you're eligible for
              </p>
              <Pagination
                v-if="loadsPagination?.totalPages > 1"
                :selected-page="+loadsPagination.currentPage"
                :total-pages="+loadsPagination.totalPages"
                @select-page="onSelectPage"
              />
            </section>
          </div>

          <div
            v-else
            class="mt-12 w-full"
          >
            <div
              class="grid border-l border-r border-transparent px-2 pb-1 font-semibold"
              :class="{
                'grid-cols-12': currentTab !== 'dispatch',
                'grid-cols-10': currentTab === 'dispatch',
              }"
            >
              <p class="col-span-2 text-xs">Load ID</p>
              <p class="col-span-2 text-xs">Status</p>
              <div
                class="col-span-2 flex cursor-pointer"
                @click="handleOriginSort"
              >
                <p class="text-start text-xs">Load Origin</p>
                <img
                  class="ml-2 h-4"
                  :class="originSort === 'asc' ? 'icon-flip' : ''"
                  src="@/assets/arrow-down-black.svg"
                  alt="arrow icon"
                />
              </div>
              <div
                class="col-span-2 flex cursor-pointer"
                @click="handleDestinationSort"
              >
                <p class="text-start text-xs">Load Destination</p>
                <img
                  class="ml-2 h-4"
                  :class="destinationSort === 'asc' ? 'icon-flip' : ''"
                  src="@/assets/arrow-down-black.svg"
                  alt="arrow icon"
                />
              </div>

              <p
                v-if="currentTab !== 'dispatch'"
                class="col-span-2 text-xs"
              >
                Truck Number
              </p>
              <p
                v-if="currentTab !== 'dispatch'"
                class="col-span-2 text-xs"
              >
                VIN
              </p>
              <p
                v-if="currentTab === 'dispatch'"
                class="col-span-2"
              ></p>
            </div>

            <div class="rounded-md border-2 border-steel-300 bg-white">
              <div
                v-for="(load, loadIndex) in loads"
                :key="load.id"
                class="grid px-2 font-normal text-neutral-subtle hover:bg-gray-50"
                :class="{
                  'border-t-2 border-steel-300': loadIndex,
                  'grid-cols-12': currentTab !== 'dispatch',
                  'grid-cols-10': currentTab === 'dispatch',
                }"
              >
                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <p class="w-full break-words px-2 text-xs">
                    {{ load.id }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <span
                    class="rounded-full px-2 text-xs font-medium capitalize"
                    :class="{
                      'bg-yellow-100 text-yellow-700':
                        load.status === 'covered',
                      'bg-blue-100 text-blue-500': load.status === 'progress',
                      'bg-green-100 text-green-800':
                        load.status === 'assumed_delivered',
                      'bg-red-150 text-red-500':
                        load.status === 'assign_vehicle' ||
                        load.status === 'available',
                    }"
                  >
                    {{ formatLoadStatus(load.status) }}
                  </span>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadOrigin(load) }}
                  </p>

                  <p class="text-xs font-normal text-neutral-subtlest">
                    {{ formatStopDate(load?.pickup_time) }}
                  </p>
                </router-link>

                <router-link
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex flex-col justify-center py-3 text-start"
                >
                  <p class="min-w-fit text-xs">
                    {{ loadDestination(load) }}
                  </p>

                  <p class="text-xs text-neutral-subtlest">
                    {{ formatStopDate(load?.dropoff_time) }}
                  </p>
                </router-link>

                <router-link
                  v-if="load.carrier_vehicle"
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <p class="text-xs">
                    {{ load?.carrier_vehicle?.truck_number || '-' }}
                  </p>
                </router-link>

                <router-link
                  v-if="load.carrier_vehicle"
                  :to="{
                    name: routerLinkName,
                    params: { id: load.id },
                  }"
                  class="col-span-2 flex items-center justify-center py-3"
                >
                  <p class="text-xs">
                    {{ load?.carrier_vehicle?.vin || '-' }}
                  </p>
                </router-link>

                <section
                  v-if="!load.carrier_vehicle"
                  class="col-span-2 flex items-center justify-center"
                >
                  <span
                    class="cursor-pointer rounded-full px-2 py-1 text-1md font-medium hover:bg-gray-200"
                    @click="openAssignVehicleBottomSheet"
                  >
                    Assign Vehicle
                  </span>
                </section>
              </div>
            </div>

            <section
              v-if="!isLoading"
              class="flex items-center justify-center py-3"
            >
              <Pagination
                v-if="canViewPagination"
                :selected-page="+loadsPagination.currentPage"
                :total-pages="+loadsPagination.totalPages"
                @select-page="onSelectPage"
              />
            </section>
          </div>
        </div>
      </div>

      <div
        v-else-if="isLoading"
        class="mt-6"
      >
        <img
          class="loading m-auto h-12 w-12"
          src="@/assets/loading-v2-yellow.svg"
          alt="loading spinner"
        />
      </div>

      <div v-else-if="doesNotMeetRequirements">
        <div
          v-if="isMissingOriginState"
          class="m-auto flex flex-col items-center gap-3"
        >
          <img
            src="@/assets/loads/semi-truck.svg"
            alt="semi truck"
          />

          <h3
            class="text-center text-xl font-semibold text-neutral-subtle-bold"
          >
            Let's get you on the road
          </h3>
          <p class="text-center font-normal text-neutral-subtle-bold">
            To get started, select an origin and/or a broker.
          </p>
        </div>

        <div
          v-else
          class="mx-4 flex flex-col gap-3 rounded-lg border border-steel-300 bg-white p-4 shadow-md"
        >
          <h3 class="text-left text-lg font-semibold text-neutral-subtle-bold">
            {{ loadErrorTitleMessage }}
          </h3>
          <p
            v-if="unauthorizedTfxUser"
            class="text-left font-normal text-neutral-subtle-bold"
          >
            Not sure why? Learn more about potential reasons
            <a
              href="https://help.highway.com/en/articles/12044805-why-can-t-i-see-loads"
              target="_blank"
              class="underline"
            >
              here
            </a>
          </p>
          <p
            v-else
            class="text-left font-normal text-neutral-subtle-bold"
          >
            {{ loadErrorMessage }}
          </p>

          <!-- <div
            v-if="unauthorizedTfxUser"
            class="mt-4 flex"
          >
            <ButtonComponent
              class="flex-1 justify-center !py-3"
              variant="primary"
            >
              <router-link
                :to="{
                  name: 'ELDConnections',
                }"
              >
                My Equipment
              </router-link>
            </ButtonComponent>
          </div> -->
        </div>
      </div>

      <div
        v-else-if="loads?.length === 0"
        class="m-4 flex flex-col items-center justify-center rounded-lg bg-white py-4"
      >
        <img
          class="h-16 w-16"
          src="@/assets/magnify.svg"
          alt=""
        />

        <div class="mx-2 flex flex-col gap-3">
          <h3 class="text-center text-lg text-gray-400">No results found.</h3>
          <h3 class="text-center text-lg text-gray-400">
            We're just getting started and new loads are being posted every day
            as more brokers join the Trusted Freight Exchange. Try adjusting
            your search filters to see more options.
          </h3>
        </div>
      </div>

      <div
        v-else
        class="grid h-full grid-cols-4 gap-3 p-4"
      >
        <div
          v-for="load in loads"
          :key="load.id"
          class="col-span-4 px-2 md:col-span-2"
        >
          <LoadDetail
            :load="load"
            :is-loads-dashboard="isLoadsDashboard"
          ></LoadDetail>
        </div>

        <InfiniteScroll @load-more="loadMoreDetails"></InfiniteScroll>
      </div>
      <div
        v-if="isLoadsRefetching && !isLoading"
        class="pb-12 pt-6"
      >
        <img
          class="loading m-auto h-12 w-12"
          src="@/assets/loading-v2-yellow.svg"
          alt="loading spinner"
        />
      </div>
    </div>
  </div>

  <LoadSortBottomSheet
    :visible="showSortBottomSheet"
    :is-loads-dashboard="isLoadsDashboard"
    @close="closeSortBottomSheet"
  >
  </LoadSortBottomSheet>
  <AssignVehicleBottomSheet
    :visible="showAssignVehicleBottomSheet"
    @close="closeAssignVehicleBottomSheet"
    @assign-vin="handleAssignVin"
  >
  </AssignVehicleBottomSheet>
  <ELDVehicleReportModal
    :visible="showEldVehicleReportModal"
    @close="closeEldVehicleReportModal"
  >
  </ELDVehicleReportModal>

  <post-capacity-modal
    v-if="showCapacityModal"
    :visible="showCapacityModal"
    :is-load-board-view="true"
    @close="closePostCapacityModal"
    @error="handlePostTruckError"
  ></post-capacity-modal>
</template>

<script setup>
import { ref, computed, onMounted, watch, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import debounce from 'lodash.debounce';
import { ButtonComponent, InfiniteScroll, Pagination } from '@/components';
import {
  AssignVehicleBottomSheet,
  BrokerImage,
  ELDVehicleReportModal,
  LoadDetail,
  LoadFiltersDesktop,
  LoadsSearchAndFilter,
  LoadSortBottomSheet,
  LoadSortMenu,
} from '@/components/loads';
import PostCapacityModal from '@/components/loads/PostCapacityModal.vue';
import { formatPrice } from '@/utils/currency';
import {
  formatStopDate,
  formatLoadStatus,
  formatEquipmentType,
} from '@/utils/loadBoardUtils.js';
import { fromNowFirstUnit } from '@/common/timestamps';

const props = defineProps({
  title: String,
  loads: Array,
  isDesktop: Boolean,
  tabs: Array,
  handleTabSelection: Function,
  currentTab: String,
  isLoading: Boolean,
  isLoadsRefetching: Boolean,
});

const emit = defineEmits(['search-loads', 'fetch-more', 'select-page']);

const store = useStore();
const router = useRouter();
const showSortBottomSheet = ref(false);

const isLoadsDashboard = computed(() => props.title === 'Find Loads');

const bannerError = computed(
  () =>
    !store.state.errors.forceHideErrorBanner &&
    store.state.errors.showErrorBanner
);

const unauthorizedTfxUser = computed(
  () => store.state.loads?.search_load_unauthorized_user
);

const loadErrorMessage = computed(
  () =>
    store.state.loads?.search_load_error?.message ||
    store.state.loads?.search_load_error
);

const loadErrorTitleMessage = computed(() =>
  unauthorizedTfxUser?.value
    ? "Sorry. You're not eligible for any routes on this lane."
    : "Let's get you on the road."
);

const doesNotMeetRequirements = computed(
  () => Object.entries(store.state.loads?.search_load_error)?.length > 0
);

const isMissingOriginState = computed(
  () =>
    loadErrorMessage?.value === 'Origin or broker required for load searching'
);

const shouldRedirect = computed(() => {
  return (
    unauthorizedTfxUser.value &&
    store.state.users?.userLoadBoardAccess?.user?.has_pending_coi_request
  );
});

const reRouteToInsuranceExchange = () => {
  console.log('Unauthorized user and has pending COI. Redirecting..');
  router.push({ name: 'File Your Insurance Exchange' });
};

watch(shouldRedirect, (newValue) => {
  if (newValue) {
    setTimeout(() => {
      reRouteToInsuranceExchange();
    }, 0);
  }
});

const resetActive = ref(false);

const handleRefreshView = async () => {
  console.log('Refresh layout view:');
  resetActive.value = true;

  const existingQuery = router.currentRoute?.value?.query;
  const existingSort = existingQuery?.sort || '';
  const query = JSON.parse(localStorage.getItem('load_search_filters')) || {};

  await store.dispatch('loads/searchLoads', {
    query,
    sort: existingSort,
  });
};

watch(
  () => props?.isLoading,
  (newValue) => {
    if (!newValue) {
      resetActive.value = false;
    }
  }
);

const routerLinkName = computed(() => 'Load Detail');

const loadsPagination = computed(() =>
  isLoadsDashboard.value
    ? store.state.loads?.loadboard_pagination
    : store.state.loads?.[`${props?.currentTab}_pagination`]
);

const numberOfLoads = computed(() => {
  if (!props.loads) {
    return 'no loads';
  } else if (props.loads?.length === 1) {
    return '1 load';
  } else {
    return `${props.loads?.length} loads`;
  }
});

const numberOfLoadsOnLoadBoard = computed(() => {
  if (!props.loads) {
    return '';
  } else if (props.loads?.length) {
    return `Showing ${props.loads?.length} load${props?.loads?.length > 1 ? 's' : ''} you're eligible for`;
  }

  return '';
});

onMounted(async () => {
  await Promise.all([
    await store.dispatch(
      'loads/getCarrierVehicles',
      store.state.users?.currentUser?.requested_carrier_id
    ),
    await store.dispatch('loads/getTruckPostings', {
      query: '?q[is_active_eq]=1',
    }),
    await store.dispatch('loads/getExpiredTruckPostings', {}),
  ]);
});

const setLoadInfo = (load) => {
  store.commit('loads/setPreLoadResponse', load);
  store.commit('loads/setLoadDetail', {
    ...load,
    stops: load?.stops?.map((stop) => ({
      ...stop,
      latitude_for_map: stop?.lat,
      longitude_for_map: stop?.lon,
    })),
  });
};

const handleMouseOver = debounce(async (load) => {
  if (store.state.users.featureFlags?.carrier_loadboard_prefetch?.enabled) {
    // console.log('mouse over for load id: ', load?.id);
    setLoadInfo(load);
  }
}, 100);

const handleSelectLoad = (load) => {
  if (store.state.users.featureFlags?.carrier_loadboard_prefetch?.enabled) {
    if (load?.id !== store.state.loads?.preloaded_load_response?.id) {
      setLoadInfo(load);
    }
  }
};

const showCapacityModal = ref(false);

const openPostCapacityModal = () => {
  showCapacityModal.value = true;
};
const closePostCapacityModal = (refetch) => {
  showCapacityModal.value = !showCapacityModal.value;

  if (refetch) {
    isRefreshSearch.value = true;

    setTimeout(() => {
      isRefreshSearch.value = false;
    }, 500);
  }
};

const handlePostTruckError = () => {};

const showEldVehicleReportModal = ref(false);

const closeEldVehicleReportModal = () => {
  showEldVehicleReportModal.value = false;
};

const showAssignVehicleBottomSheet = ref(false);

const openAssignVehicleBottomSheet = () => {
  showAssignVehicleBottomSheet.value = true;
};

const closeAssignVehicleBottomSheet = () => {
  showAssignVehicleBottomSheet.value = false;
};

const handleAssignVin = (vin) => {
  console.log('clicked vin: ', vin);
  showEldVehicleReportModal.value = true;
};

const openSortBottomSheet = () => {
  showSortBottomSheet.value = true;
};

const closeSortBottomSheet = () => {
  showSortBottomSheet.value = false;
};

const searchLoadsInput = (term) => {
  emit('search-loads', term);
};

const loadMoreDetails = () => {
  emit('fetch-more');
};

const onSelectPage = (page) => {
  emit('select-page', page);
};

const capitalizeWords = (word) => {
  return word
    .toLowerCase()
    .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
    .replace('Llc', 'LLC');
};

const loadOrigin = (load) => {
  const origin = load?.stops?.[0] || load?.origin;

  const city = capitalizeWords(
    origin?.city || origin?.area_five_zip_city || ''
  );
  const state = origin?.state || origin?.area_five_zip_state || '';

  if (!city) {
    return '-';
  }

  return `${city}${state ? ', ' + state : ''}`;
};

const loadDestination = (load) => {
  const destination =
    load?.stops?.[load?.stops?.length - 1] || load?.destination;

  const city = capitalizeWords(
    destination?.city || destination?.area_five_zip_city || ''
  );
  const state = destination?.state || destination?.area_five_zip_state || '';

  if (!city) {
    return '-';
  }

  return `${city}${state ? ', ' + state : ''}`;
};

const originSort = computed(() => {
  const sortQuery = router.currentRoute.value.query?.sort;
  const [key, value] = sortQuery?.split('_') || [];

  if (key === 'origin') {
    return value;
  } else {
    return 'desc';
  }
});

const handleOriginSort = () => {
  if (isLoadsDashboard?.value) {
    return;
  }
  const sortDirection = originSort.value === 'asc' ? 'desc' : 'asc';
  console.log('New Sort Direction: ', sortDirection);

  router.push({
    query: {
      ...router.currentRoute.value.query,
      sort: `origin_${sortDirection}`,
    },
  });
};

const destinationSort = computed(() => {
  const sortQuery = router.currentRoute.value.query?.sort;
  const [key, value] = sortQuery?.split('_') || [];

  if (key === 'destination') {
    return value;
  } else {
    return 'desc';
  }
});

const handleDestinationSort = () => {
  if (isLoadsDashboard?.value) {
    return;
  }
  const sortDirection = destinationSort.value === 'asc' ? 'desc' : 'asc';

  router.push({
    query: {
      ...router.currentRoute.value.query,
      sort: `destination_${sortDirection}`,
    },
  });
};

// const handleLearnMore = () => {
//   console.log('Learn More');
//   window.open(store.state.loads?.search_load_error?.redirect_link, '_blank');
// };

const isResettingSearch = ref(false);
const isRefreshSearch = ref(false);

// const handleResetSearch = async () => {
//   isResettingSearch.value = true;

//   await store.commit('loads/setLoadSearchFilters', {});
//   await store.commit('loads/setSearchLoadError', {});
//   await store.commit('laneSearches/setAutocompleteResults', {
//     results: [],
//     isType: 'origin',
//   });
//   await store.commit('laneSearches/setAutocompleteResults', {
//     results: [],
//     isType: 'destination',
//   });
//   await router.push({
//     query: {},
//   });

//   isResettingSearch.value = false;
// };

const querySort = computed(() => router.currentRoute?.value?.query?.sort || '');

const sortHash = {
  rpm: 'RPM',
  posting_desc: 'Posting',
  price_desc: 'Price',
  distance_asc: 'Distance Asc',
  distance_desc: 'Distance Desc',
  deadhead: 'Deadhead',
};

const postingSort = computed(() =>
  querySort?.value ? sortHash[querySort?.value] : 'Latest'
);

const weightUnit = {
  pound: 'lbs',
  kilogram: 'kg',
};

const loadWeight = (weight, weight_unit) => {
  if (weight === 0) return '-';
  return `${weight?.toLocaleString('en-US')} ${weightUnit[weight_unit]}`;
};

const loadRateClass = (rate) => {
  switch (rate) {
    case 'Great':
      return 'bg-aqua-700 text-white';
    case 'Good':
      return 'bg-aqua-500 text-white';
    case 'Fair':
      return 'bg-aqua-300 text-steel-1100';
    case 'Below':
      return 'bg-red-100 text-red-600';
    default:
      return '';
  }
};
const loadRateText = () => {
  return null;

  // switch (rate) {
  //   case 'Great':
  //     return 'Great Deal';
  //   case 'Good':
  //     return 'Good Deal';
  //   default:
  //     return null;
  // }
};

const loadRate = (rate) => {
  if (!rate) return null;
  return formatPrice(rate);
};
</script>

<style>
.icon-flip {
  transform: scale(-1);
}

.table-max {
  max-width: 92rem;
}
</style>
